import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { ModalPermissionComponent } from '../modal-permission/modal-permission.component';
import { ModalConfirmationComponent } from '../modal-confirmation/modal-confirmation.component';
import { LoadingService } from 'src/app/services/loading.service';
import { RolesService } from 'src/app/services/roles.service';
import { IUserInfo } from 'src/app/admin/models/user.interface';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-modal-roles',
  templateUrl: './modal-roles.component.html',
  styleUrls: ['./modal-roles.component.scss'],
})
export class ModalRolesComponent implements OnInit {


  public name!: string;
  public lastName!: string;
  public id!: number;
  public hasLicense!: boolean;

  onLicenceChange: any

  loggedUserInfo!: IUserInfo;

  initials?: string;

    constructor(
      private modalController: ModalController, navParams: NavParams,
      private loadingService: LoadingService, private rolesService: RolesService,
      private authService: AuthService) {
    this.name = navParams.get('name');
    this.lastName = navParams.get('lastName');
    this.id = navParams.get('id');
    this.hasLicense = navParams.get('hasLicense');
    this.onLicenceChange = navParams.get('onLicenceChange');

    this.loggedUserInfo = this.authService.getAppUser();
  }

  ngOnInit() {}

  closeModal() {
    this.modalController.dismiss();
  }
  
  async openmodal() {
    const modal = await this.modalController.create({
      component: ModalPermissionComponent,
      cssClass: 'modal-class-permmission',
      componentProps: {
        id : this.id
      }
    });
    return await modal.present();
  }
  getInitials(name) {
    let palabras = name.split(' ');
    palabras =
      palabras.length >= 4
        ? [palabras[0], palabras[2]]
        : palabras.length == 3
        ? [palabras[0], palabras[1]]
        : palabras;
    return palabras.map((palabra) => palabra[0]).join('').toUpperCase();
  }

  get isSystemAdmin() {
    return this.loggedUserInfo.system_admin;
  }


  async showConfirmationModal(){

    const modal = await this.modalController.create({
      component: ModalConfirmationComponent,
      cssClass: 'modal-class-confimartion',
      componentProps: {
        confirmationText: `¿Estás seguro de que deseas ${this.hasLicense ? 'desactivar' : 'activar'} la licencia a este usuario?`
      }
    });
    modal.present();
    return modal.onDidDismiss();
  }


  async updateLicense() {
    const result = await this.showConfirmationModal();
    if (!result || !result.data || !result.data.accepted) {
      this.hasLicense = !this.hasLicense;
      return
    }
    this.loadingService.show();
    this.rolesService.updateLicence(this.id, this.hasLicense).subscribe(
      {
        next: (data) => {
          this.hasLicense = data.has_license;
          if(this.onLicenceChange) this.onLicenceChange(this.hasLicense, {id: this.id});
          this.loadingService.hide();
        },
        error: (error) => {
          console.error("Error updating licence", error.error);
          if(error.error && error.error.non_field_errors){
            for(let e of error.error.non_field_errors){
              if(e.includes('There are not available licences')){
                this.hasLicense = false;
                this.showNoLicenseModal();
              }
            }
          }
          this.loadingService.hide();
        }
      }
    );
  }

  async showNoLicenseModal(){
    const modal = await this.modalController.create({
      component: ModalConfirmationComponent,
      cssClass: 'modal-class-confimartion',
      componentProps: {
        confirmationText: `Actualmente no tienes más licencias disponibles. Desactiva la licencia de otro usuario para poder asignársela a este.`
      }
    });
    modal.present();
    return modal.onDidDismiss();
  }

}
